import { RootState } from '../types'

export const getSession = (state: RootState) => state.session

export const isLoggedIn = (state: RootState) =>
  getSession(state).accessToken !== '' && getSession(state).accessToken !== null
